
define('app/board/views/teamHeaderView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/leagueInstanceModel',
	'known/models/userModel',
	
	//Templates
	'text!app/board/templates/teamHeaderTemplate.html',
], function($, _, Backbone, LeagueInstanceModel, UserModel, teamHeaderHtml){
	var TeamHeaderView = Backbone.View.extend({
		initialize: function(options) {
			this.leagueUser = options.leagueUser;
			this.fantasyTeam = options.fantasyTeam;
			this.draftOptions = options.draftOptions;
			this.user = options.user;
			this.leagueInst = options.leagueInst;
			this.draftStatusModel = options.draftStatusModel;
			this.submittedData = {isSubmitted : false};
			
			this.currentRoundPosId = 0;
			this.currentWinningBid = 0;
			this.currentTeamBid = 0;
			this.bidRanking = 99;
			
			this.template = _.template(teamHeaderHtml.trim());
			
			_.bindAll(this, 'submitBid');
			_.bindAll(this, 'error');
			_.bindAll(this, 'success');
			
			this.buildEl();
			
			this.listenTo(this.leagueUser, 'change:timeSinceActivity', this.updateUserVisuals);
			this.listenTo(this.draftOptions, 'change', this.setElStyle);
			this.listenTo(this.user, 'change', this.updateUserVisuals);
			
			if(this.leagueInst.get('draftType') == 'AUCTION'){
				this.listenTo(this.draftStatusModel, 'change', this.updateAuctionInfo);
			}
		},
	
		render: function () {		
			this.setElStyle();
			this.updateAuctionInfo();
			
			return this;
		},
		
		buildEl: function() {
			this.setElement($(this.template({teamName: this.fantasyTeam.get('teamName')})));
			
			this.auctionMainInfoEl = this.$el.find('.teamHdrAuctionMainInfo');
			this.auctionBidInfoEl = this.$el.find('.teamHdrBidInfo');
			this.auctionBudgetInfoEl = this.$el.find('.teamHdrAuctionBudgetInfo');
			this.auctionMaxAvgInfoEl = this.$el.find('.teamHdrAuctionBidMaxAvgInfo');
			this.auctionBidBtnContainerEl = this.$el.find('.teamHdrBidBtn');
			this.auctionBidBtnEl = this.auctionBidBtnContainerEl.find('button');
			this.auctionBidInputEl = this.auctionBidBtnContainerEl.find('input');
			
			if(this.leagueInst.get('draftType') == 'AUCTION'){
				this.auctionBidBtnEl.on('click', {}, this.submitBid);
			}
		},
		
		submitBid: function(event) {
			event.preventDefault();
			
			if(!this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = true;
				/*
				{
					"leagueInstanceId":14474, //
					"fantasyTeamId":151965, //
					"draftablePlayerId":1439, //
					"value":0, //
					"round":1, //
					"keeper":false, //}  
				 
				 draftStatusModel.set({
					auctionBidding: true,
					auctionPickId : jsonItem.id,
					auctionBidValue: jsonItem.draftTimer.auctionValue,
					auctionWinningTeamId: jsonItem.draftTimer.auctionTeamId});
				 
				 */
				
				var valueInput = this.auctionBidInputEl.val();
				var numPattern = new RegExp("^[0-9]*$");
				var error = false;
				
				if(!valueInput){
					error = true;
				} else if(valueInput && valueInput.length == 0){
					error = true; 
				} else if(!valueInput.match(numPattern)){
					error = true; 
				}
				
				if(error){
					this.error();
					return this;
				}
				
				valueInput = parseInt(valueInput);
				var curBudget = this.draftStatusModel.get('teamBudget')[this.fantasyTeam.get('id')];
				var playersPicked = this.draftStatusModel.get('teamPickCount')[this.fantasyTeam.get('id')];
				var maxPlayers = this.draftStatusModel.get('teamMaxNumPicks')[this.fantasyTeam.get('id')];
				var maxBid = curBudget-(maxPlayers-playersPicked)+1;
				
				if(valueInput <= this.draftStatusModel.get('auctionBidValue') || valueInput > maxBid || valueInput < 1 || valueInput > 999) {
					error = true;
				}
				
				if(error){
					this.error();
					return this;
				} else {
					var round = this.draftStatusModel.get('round');
					var posInRound = this.draftStatusModel.get('posInRound');
					var keeper = false;
					var autoDrafted = false;
					
					var msg = {
							"leagueInstanceId":this.leagueInst.get('id'), 
							"fantasyTeamId":this.fantasyTeam.get('id'), 
							"draftablePlayerId":this.draftStatusModel.get('auctionBidPlayerId'), 
							"value":valueInput, 
							"round":round,
							"posInRound":posInRound, 
							"keeper":keeper};
					
					$.ajax({
						headers : {
							"Content-Type" : "application/json",
							"Accept" : "application/json"
						},
						url : '/draftapp/leagues/' 
							+ this.leagueInst.get('leagueId') 
							+ '/league-instances/' 
							+ this.leagueInst.get('id')
							+ '/picks/'
							+ this.draftStatusModel.get('auctionPickId'),
						type : 'PUT',
						dataType : 'json',
						//accepts: 'application/json',
						//contentType: 'application/json',
						data : JSON.stringify(msg, null, 2),
						success: this.success,
						error: this.error
					});
				}
			}
		},
		
		error: function() {
			this.auctionBidInputEl.addClass('error');
			this.submittedData.isSubmitted = false;
		},
		
		success: function() {
			this.auctionBidInputEl.removeClass('error');
			this.submittedData.isSubmitted = false;
		},
		
		setElStyle: function() {
			//this.$el.css({'width': this.draftOptions.get('pickWidth') + 'px'}); //Fixed Header Revert
			this.$el.css({
				'min-width': this.draftOptions.get('pickWidth') + 'px', 
				'max-width': this.draftOptions.get('pickWidth') + 'px',
				'font-size': this.draftOptions.get('teamFontSize') + 'px',
				'line-height': (this.draftOptions.get('teamFontSize') + 8) + 'px'});
				
			this.updateUserVisuals();
		},
		
		updateAuctionInfo: function() {
			//new bid so reset the cached numbers
			if(this.currentRoundPosId != ((this.draftStatusModel.get('round') * 1000) + this.draftStatusModel.get('posInRound')) || !this.draftStatusModel.get('auctionBidding')){
				this.currentRoundPosId = (this.draftStatusModel.get('round') * 1000) + this.draftStatusModel.get('posInRound');
				this.currentWinningBid = 0;
				this.currentTeamBid = 0;
				this.bidRanking = 99;
				
				if(!$(this.auctionBidInputEl).is(':focus')){
					this.auctionBidInputEl.val(1);
				}
			}
			
			if(this.draftStatusModel.get('auctionBidding') && this.currentWinningBid != this.draftStatusModel.get('auctionBidValue')){
				this.currentWinningBid = this.draftStatusModel.get('auctionBidValue');
				
				if(this.fantasyTeam.get('id') == this.draftStatusModel.get('auctionWinningTeamId')){
					this.currentTeamBid = this.draftStatusModel.get('auctionBidValue');
					this.bidRanking = 1;
				} else {
					this.bidRanking = this.bidRanking + 1;
				}
			}
			
			if(this.leagueInst.get('draftType') == 'AUCTION'){
				var curBudget = this.draftStatusModel.get('teamBudget')[this.fantasyTeam.get('id')];
				var playersPicked = this.draftStatusModel.get('teamPickCount')[this.fantasyTeam.get('id')];
				var maxPlayers = this.draftStatusModel.get('teamMaxNumPicks')[this.fantasyTeam.get('id')];
				var maxBid = curBudget-(maxPlayers-playersPicked) + 1;
				
				//$XXX XX/XX
				this.auctionMainInfoEl.html(
						'$'
						+ curBudget
						+ ' '
						+ playersPicked
						+ '/'
						+ maxPlayers);
				this.auctionBidInfoEl.html('<span class="label">$' + this.currentTeamBid + '</span>');
				this.auctionBudgetInfoEl.show();
				
				//M:$XXX A:$XX.X
				this.auctionMaxAvgInfoEl.html(
						'M:$'
						+ ((maxPlayers-playersPicked) <= 0 ? 0 : maxBid)
						+ ' A:$'
						+ ((maxPlayers-playersPicked) <= 0 ? 0 : parseFloat(curBudget/(maxPlayers-playersPicked)).toFixed(1))); 
				this.auctionMaxAvgInfoEl.show();
				
				if(this.bidRanking == 1){
					this.$el.removeClass('losingBidTeam');
					this.$el.removeClass('eliminatedBidTeam');
					this.$el.addClass('winningBidTeam');
				} else if(playersPicked >= maxPlayers) {
					this.$el.removeClass('winningBidTeam');
					this.$el.removeClass('losingBidTeam');
					this.$el.addClass('eliminatedBidTeam');
				} else if(this.draftStatusModel.get('auctionBidValue') >= maxBid) {
					this.$el.removeClass('winningBidTeam');
					this.$el.removeClass('losingBidTeam');
					this.$el.addClass('eliminatedBidTeam');
				} else if(this.currentTeamBid > 0) {
					this.$el.removeClass('winningBidTeam');
					this.$el.removeClass('eliminatedBidTeam');
					this.$el.addClass('losingBidTeam');
				} else {
					this.$el.removeClass('winningBidTeam');
					this.$el.removeClass('losingBidTeam');
					this.$el.removeClass('eliminatedBidTeam');
				}
				
				//increment the bid if it is less than or equal to current winning bid
				if(!$(this.auctionBidInputEl).is(':focus') && (!$.isNumeric(this.auctionBidInputEl.val()) || parseInt(this.auctionBidInputEl.val()) <= this.draftStatusModel.get('auctionBidValue'))) {
					this.auctionBidInputEl.val(this.draftStatusModel.get('auctionBidValue') + 1);
					this.auctionBidInputEl.removeClass('error');
				}
				
				var userName = this.user.get('userName');
				var isAssistant = this.leagueInst.isAssistant(userName);
				var teamOwner = this.leagueInst.getTeamOwner(this.fantasyTeam.get('id'));
				
				if(this.bidRanking == 1 || this.currentWinningBid > maxBid || playersPicked >= maxPlayers){
					this.auctionBidBtnContainerEl.addClass('bidNotAllowed');
				} else if(this.draftStatusModel.get('auctionBidding') && (isAssistant || userName.toUpperCase() == teamOwner.toUpperCase())){
					this.auctionBidBtnContainerEl.removeClass('bidNotAllowed');
				} else if(!this.user.isGuest()){
					this.auctionBidBtnContainerEl.addClass('bidNotAllowed');
				} else {
					this.auctionBidBtnContainerEl.removeClass('bidNotAllowed');
				}
			}
		},
		
		updateUserVisuals: function () {
			var teamOwner = this.leagueInst.getTeamOwner(this.fantasyTeam.get('id'));
			var userName = this.user.get('userName');
			var isAssistant = this.leagueInst.isAssistant(userName);
			
			if(this.draftOptions.get('hideActivityIcon')){
				this.$el.find('.onlineStatus').hide();
				this.$el.find('.awayStatus').hide();
				this.$el.find('.offlineStatus').hide();
				this.$el.find('.curUserOnlineStatus').hide();
			} else if(this.leagueUser.get('timeSinceActivity') < 1000 * 60 && userName.toUpperCase() == teamOwner.toUpperCase()){
				//User owns this team and has activity in the last minute - owner status
				this.$el.find('.onlineStatus').hide();
				this.$el.find('.awayStatus').hide();
				this.$el.find('.offlineStatus').hide();
				this.$el.find('.curUserOnlineStatus').show();
			} else if(this.leagueUser.get('timeSinceActivity') < 1000 * 60){
				//User has activity within the last minute - online status
				this.$el.find('.curUserOnlineStatus').hide();
				this.$el.find('.awayStatus').hide();
				this.$el.find('.offlineStatus').hide();
				this.$el.find('.onlineStatus').show();
			} else if(this.leagueUser.get('timeSinceActivity') < 1000 * 60 * 30){
				//User was inactive over a minute, but logged in recently - away status
				this.$el.find('.curUserOnlineStatus').hide();
				this.$el.find('.onlineStatus').hide();
				this.$el.find('.offlineStatus').hide();
				this.$el.find('.awayStatus').show();
			} else {
				//User hasn't logged in recently - away status
				this.$el.find('.curUserOnlineStatus').hide();
				this.$el.find('.onlineStatus').hide();
				this.$el.find('.awayStatus').hide();
				this.$el.find('.offlineStatus').show();
			}
			
			if(this.leagueInst.get('draftType') == 'AUCTION'){
				//Change color of button for commish
				if(isAssistant && userName.toUpperCase() != teamOwner.toUpperCase()){
					this.auctionBidBtnEl.removeClass('btn-success');
					this.auctionBidBtnEl.addClass('btn-info');
					this.auctionBidBtnContainerEl.css({'visibility': ''});
					this.auctionBidBtnContainerEl.show();
				} else if(userName.toUpperCase() == teamOwner.toUpperCase()){
					this.auctionBidBtnEl.removeClass('btn-info');
					this.auctionBidBtnEl.addClass('btn-success');
					this.auctionBidBtnContainerEl.css({'visibility': ''});
					this.auctionBidBtnContainerEl.show();
				} else if(!this.user.isGuest()){
					this.auctionBidBtnEl.removeClass('btn-info');
					this.auctionBidBtnEl.addClass('btn-success');
					this.auctionBidBtnContainerEl.css({'visibility': 'hidden'});
					this.auctionBidBtnContainerEl.show();
				} else {
					this.auctionBidBtnEl.removeClass('btn-info');
					this.auctionBidBtnEl.addClass('btn-success');
					this.auctionBidBtnContainerEl.css({'visibility': ''});
					this.auctionBidBtnContainerEl.hide();
				}
			}
		}
	});

	return TeamHeaderView;  
});